import React, { Fragment } from "react";

import BlueLogo from "./BlueLogo";

const DeclineEmployerCasualRequestConfirm = ({
  user,
  notification,
  setdeclineemployercasualrequest,
  profile: { avatar, firstname, lastname, companyname, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="subscription-box-confirmation">
          <i
            className="far fa-times-circle blue fa-3x subscription-x"
            onClick={() =>
              setdeclineemployercasualrequest({
                request: false,
                confirm: false,
              })
            }
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <BlueLogo />
            </p>
            <h1 className="subscription-name blue">Friend Request Declined</h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 blue"></i>
                  <p className="sub-section blue">Friend declined:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt blue">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="blue name-font bold">{companyname}</span>
                    </li>
                    <li className="user-online-item">
                      {firstname} {lastname}
                    </li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 blue"></i>
                  <p className="sub-section blue">Friend declined:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt blue">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="blue name-font bold">
                        {user.companyname}
                      </span>
                    </li>
                    <li className="user-online-item">
                      {user.firstname} {user.lastname}
                    </li>
                    <li className="user-online-item">
                      {user.location.city}, {user.location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              {notification && notification.msg}
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DeclineEmployerCasualRequestConfirm;
